import { GoogleMap, LoadScript, Marker } from '@react-google-maps/api';

const CustomMap = (props: any) => {

  const mapStyles:any = {
    "height":  props.height ? `${props.height - 10}px` : 'inherit',
    "width": "100%",
    "backgroundRepeat": "no-repeat",
    "position": "relative",
    "zIndex": 2,
  };

  const defaultCenter = {
    lat: 60.1699, lng: 24.9384
  }

  const mapOptions = {
    zoomControl: props?.type && props?.type === 'pdf' ? false : true,
    streetViewControl: props?.type && props?.type === 'pdf' ? false : true,
    fullscreenControl: props?.type && props?.type === 'pdf' ? false : true,
    mapTypeControl: props?.type && props?.type === 'pdf' ? false : true
  }

  return (
    <LoadScript
      googleMapsApiKey='AIzaSyDU5pjsfbg36WDQF542Y3k9AOParJwx1Bo'>
      <GoogleMap
        mapContainerStyle={mapStyles}
        zoom={13}
        center={props?.locations?.length > 0 ? props?.locations[0]?.location : defaultCenter}
        options={ mapOptions}
        >
        {
            props?.locations?.length > 0 ? props?.locations?.map((item:any) => {
              return (
              <Marker key={Math.random()} position={item?.location}/>
              )
            }) : <Marker key={Math.random()} position={defaultCenter}/>
         }
      </GoogleMap>
    </LoadScript>
  )
}

export default CustomMap;
